// extracted by css-extract-rspack-plugin
export default {"moreInfoRows":"more-information-module__moreInfoRows___bIcfk","name":"more-information-module__name___SnDyl","text":"more-information-module__text___k6uRK"};